import { Status } from './wire-format.mjs';
export const Validators = {
    NonEmptyString: {
        instructions: '',
        test: (input) => {
            if (input.length !== 0) {
                return {
                    status: Status.ok,
                    msg: '',
                };
            }
            else {
                return {
                    status: Status.error,
                    msg: 'Input cannot be empty',
                };
            }
        },
    },
};
//# sourceMappingURL=validators.js.map